export default __webpack_public_path__ + "static/media/arrow-double.25891292.svg";